import { render, staticRenderFns } from "./NewDevRevenue.vue?vue&type=template&id=dc9fba6c"
import script from "./NewDevRevenue.vue?vue&type=script&lang=js"
export * from "./NewDevRevenue.vue?vue&type=script&lang=js"
import style0 from "./NewDevRevenue.vue?vue&type=style&index=0&id=dc9fba6c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./NewDevRevenue.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports